// В.2.b: Полевой санитар (liv_polevoy_sanitar, common, 1/2/3).
// [Аура]: лечит +1 ХП ВСЕМ союзным юнитам на той же линии (включая себя).
// Героя НЕ лечит. Через healUnit (триггерит событие healed). В обоих раундах.
// Молчание блокирует — это уже в каркасе runLivLifeHealAuras.

import { registerLivLifeHealAura } from './heal-auras.js';
import { registerImplementedAbility } from './warn-unimplemented.js';
import { healUnit } from './heal.js';

export const CARD_ID = 'liv_polevoy_sanitar';
const HEAL_AMOUNT = 1;

registerImplementedAbility(CARD_ID, 'passive');

registerLivLifeHealAura(CARD_ID, (state, card, _round) => {
  const owner = state.players?.[card.ownerId];
  if (!owner) return;
  const line = card.line;
  if (line == null) return;
  for (let s = 0; s < 4; s++) {
    const ally = owner.field?.[line]?.[s];
    if (!ally) continue;
    if (!ally.isAlive || !ally.isAlive()) continue;
    healUnit(state, ally, HEAL_AMOUNT, card);
  }
});
